import { render, staticRenderFns } from "./free-gifts-viewer.vue?vue&type=template&id=a39b137c&scoped=true"
import script from "./free-gifts-viewer.vue?vue&type=script&lang=js"
export * from "./free-gifts-viewer.vue?vue&type=script&lang=js"
import style0 from "./free-gifts-viewer.vue?vue&type=style&index=0&id=a39b137c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39b137c",
  null
  
)

export default component.exports